import { couponActions } from "../../actionTypes";

const initialState = {
	coupon: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case couponActions.UPDATE_NEWS: {
			return { ...state, ...initialState };
		}

		case couponActions.UPDATE_NEWS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				coupon: action.payload,
			};
		}

		case couponActions.UPDATE_NEWS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
